// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import Confetti, { ConfettiConfig } from "react-dom-confetti"
import * as styles from "./styles.module.scss"
import LinkButton from "../LinkButton"

interface Props {
  contactEmail?: string
  confettiConfig?: ConfettiConfig
}

const defaultProps: Props = {
  contactEmail: "contact@onemoregame.com",
  confettiConfig: {
    angle: 90,
    spread: 120,
    startVelocity: 45,
    elementCount: 120,
    dragFriction: 0.1,
    duration: 3000,
    stagger: 0,
    colors: [
      `${styles.primaryConfettiColor}`,
      `${styles.secondaryConfettiColor}`,
      `${styles.tertiaryConfettiColor}`,
    ],
  },
}

const ChatWidget: React.FC<Props> = (props: Props) => {
  const data = useStaticQuery(graphql`
    query {
      chatWidgetIcon: file(relativePath: { eq: "chat-widget.png" }) {
        childImageSharp {
          fluid(maxWidth: 28, maxHeight: 28) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  const [isOpen, setOpen] = useState(false)
  const [isPlayAnim, setPlayAnim] = useState(false)

  const widgetStyle = (): string => {
    if (isOpen) {
      return `${styles.overlay} ${styles.show}`
    }
    return styles.overlay
  }

  const toggleAnim = () => {
    // jamie todo: this shouldn't be a toggle. Instead we should
    // play the animation for the duration and then allow this
    // to be called again afterwards.
    setPlayAnim(!isPlayAnim)
  }

  const toggleOpen = () => {
    setOpen(!isOpen)
  }

  return (
    <div>
      <div className={styles.root} onClick={toggleOpen}>
        <Img
          fluid={data.chatWidgetIcon.childImageSharp.fluid}
          className={styles.imageIcon}
          style={{ width: "100%" }}
          alt="chat widget"
        />
      </div>
      <div className={widgetStyle()}>
        <Confetti active={isPlayAnim} config={props.confettiConfig} />
        <div className={styles.overlayContainer}>
          <div className={styles.closeButton} onClick={toggleOpen}>
            Close
          </div>
          <div>
            This chat widget is pretty, isn't it? It doesn't do anything, but
            does makes things look more <i>official</i>, yeah? We'll invite you
            to the{" "}
            <LinkButton className={styles.confettiLink} onClick={toggleAnim}>
              party
            </LinkButton>{" "}
            soon!
          </div>
        </div>
      </div>
    </div>
  )
}

ChatWidget.defaultProps = defaultProps

export default ChatWidget
